export const characteristicsCardsData = [
  {
    title:
      "Assists each soul in the expression of uniqueness, even as unveiling each soul's universality.",
  },
  {
    title: "Requires no change of clothes or beliefs or lifestyle.",
  },
  {
    title: "Works every time, from the first use.",
  },
  {
    title: "Is for all - no matter one's caste, creed, color or country.",
  },
  {
    title: "Is dynamic enough to awaken Shakti - the Inner Energy.",
  },
  {
    title:
      "Helps all those who are interested progress spiritually as rapidly & safely as possible.",
  },
  {
    title:
      "Helps all those who are interested progress spiritually as rapidly & safely as possible.",
  },
  {
    title:
      "Contains all yogas, all true teachings, and offers all spiritual blessings.",
  },
  {
    title: "Develops each aspirant in a full & holistic manner.",
  },
];
